import { render, staticRenderFns } from "./addShift.vue?vue&type=template&id=5cb0fc60&scoped=true"
import script from "./addShift.vue?vue&type=script&lang=js"
export * from "./addShift.vue?vue&type=script&lang=js"
import style0 from "./addShift.vue?vue&type=style&index=0&id=5cb0fc60&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb0fc60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cb0fc60')) {
      api.createRecord('5cb0fc60', component.options)
    } else {
      api.reload('5cb0fc60', component.options)
    }
    module.hot.accept("./addShift.vue?vue&type=template&id=5cb0fc60&scoped=true", function () {
      api.rerender('5cb0fc60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/attendance/setting/components/addShift.vue"
export default component.exports